import { render, staticRenderFns } from "./ContentTypeValueList.vue?vue&type=template&id=6a74560e&scoped=true"
import script from "./ContentTypeValueList.vue?vue&type=script&lang=js"
export * from "./ContentTypeValueList.vue?vue&type=script&lang=js"
import style0 from "./ContentTypeValueList.vue?vue&type=style&index=0&id=6a74560e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a74560e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
